import type { HTTPFunctions, CacheParameter, FavIconColorContrast, WebDetailsResponse } from './types';

const webChecker = ({ get, post }: HTTPFunctions) => ({
  getAccesibilityHTML: (url: string, cache: CacheParameter) => get<string>(`/accesibility/html/${cache}/?url=${url}`),
  getFavIconColorContrast: (url: string) => post<FavIconColorContrast>(`/accesibility/check-contrast`, {image_url: url, min_ratio: 4.5}),
  getWebDetails: (url: string) => post<WebDetailsResponse>(`/accesibility/website-details?url=${url}`, {})
});

export default webChecker;

